import React, { Component } from "react";
import "./style.css";
import "../../../../index.css";
let params = { majorCategoryId: null, majorName: null, majorTypeId: null };
class MajorFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterCategoryId: null,
      filterMajorTypeId: null,
      filterLevelId: 1,
    };
  }
  render() {
    const { visible, handleVisibleFilter, filterData } = this.props;
    return (
      <div
        style={visible === true ? { display: "block" } : { display: "none" }}
        className="major_filter_box"
      >
        <div className="major_filter_inline_box fr">
          <div className="major_filter_inline_box_top">
            <div className="major_filter_inline_box_top_inline">
              <div
                onClick={() => this.activeTab(1)}
                className={
                  this.state.filterLevelId === 1
                    ? "major_filter_inline_box_top_inline_btn_active fl"
                    : "major_filter_inline_box_top_inline_btn fl"
                }
              >
                本 科
                <img
                  alt=""
                  src={require("../../../../images/search/search_0.png")}
                ></img>
              </div>
              <div
                onClick={() => this.activeTab(2)}
                className={
                  this.state.filterLevelId === 2
                    ? "major_filter_inline_box_top_inline_btn_active fr"
                    : "major_filter_inline_box_top_inline_btn fr"
                }
              >
                专 科
                <img
                  alt=""
                  src={require("../../../../images/search/search_0.png")}
                ></img>
              </div>
            </div>
          </div>
          <div className="major_filter_inline_box_shim"></div>
          <div className="major_filter_inline_box_middle">
            <div className="major_filter_inline_box_middle_left fl">
              {filterData != null ? (
                <div>
                  {filterData.map((item, index) => {
                    return (
                      <div
                        onClick={() =>
                          this.handleCategoryClick(index, item.categoryId)
                        }
                        key={index}
                        className="major_filter_inline_box_middle_left_item"
                      >
                        <div className="major_filter_inline_box_middle_left_item_inline">
                          <div
                            className={
                              this.state.filterCategoryId === index
                                ? "major_filter_inline_box_middle_left_item_inline_left_active fl"
                                : "major_filter_inline_box_middle_left_item_inline_left fl"
                            }
                          >
                            {item.categoryName}
                          </div>
                          <div className="major_filter_inline_box_middle_left_item_inline_right fr">
                            <img
                              alt=""
                              src={
                                this.state.filterCategoryId === index
                                  ? require("../../../../images/major/arrow_active.png")
                                  : require("../../../../images/major/arrow.png")
                              }
                            ></img>
                          </div>
                          <div className="clear"></div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="major_filter_inline_box_middle_right fr">
              {filterData[this.state.filterCategoryId] != null ? (
                <div>
                  {filterData[this.state.filterCategoryId].majorTypeFilters.map(
                    (item, index) => {
                      return (
                        <div
                          onClick={() =>
                            this.handleMajorTypeClick(item.majorTypeId, index)
                          }
                          key={index}
                          className="major_filter_inline_box_middle_right_item"
                        >
                          <div
                            className={
                              this.state.filterMajorTypeId === index
                                ? "major_filter_inline_box_middle_right_item_inline_active"
                                : "major_filter_inline_box_middle_right_item_inline"
                            }
                          >
                            {item.majorType}
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="clear"></div>
          </div>
          <div className="major_filter_inline_box_bottom">
            <div className="major_filter_inline_box_bottom_inline">
              <div
                onClick={() => this.handleReset()}
                className="major_filter_inline_box_bottom_btn_fl fl"
              >
                重置
              </div>
              <div
                onClick={() => this.handleConfirm()}
                className="major_filter_inline_box_bottom_btn_fr fr"
              >
                确定
              </div>
            </div>
          </div>
        </div>
        <div
          onClick={handleVisibleFilter}
          className="major_filter_inline_click fl"
        ></div>
      </div>
    );
  }
  /**
   * 切换标签
   */
  activeTab = (id) => {
    params = { majorCategoryId: null, majorName: null, majorTypeId: null };
    this.setState({
      filterLevelId: id,
      filterCategoryId: null,
      filterMajorTypeId: null,
    });
    this.props.handleAddScroll();
    this.props.requestMajorFilter(id);
    this.props.handleChangeParams(params);
  };
  /**
   * 点击专业大类
   */
  handleCategoryClick = (id, categoryId) => {
    params = {
      majorCategoryId: categoryId,
      majorName: null,
      majorTypeId: null,
    };
    this.setState({
      filterCategoryId: id,
      filterMajorTypeId: null,
    });
    this.props.handleChangeParams(params);
  };
  /**
   * 点击专业
   */
  handleMajorTypeClick = (majorTypeId, id) => {
    params.majorTypeId = majorTypeId;
    this.setState({
      filterMajorTypeId: id,
    });
    this.props.handleChangeParams(params);
  };
  /**
   * 确认
   */
  handleConfirm = () => {
    this.props.requestFilterMajorList();
    this.props.handleVisibleFilter();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  };
  /**
   * 重置
   */
  handleReset = () => {
    params = { majorCategoryId: null, majorName: null, majorTypeId: null };
    this.setState({
      filterCategoryId: null,
      filterMajorTypeId: null,
    });
    this.props.handleChangeParams(params);
    this.props.handleAddScroll();
  };
}
export default MajorFilter;



// WEBPACK FOOTER //
// ./src/containers/Major/components/MajorFilter/index.js